import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { InstgramData } from './InstgramData';
import Heading from '../../Fashion/Heading';
import HeadingTwo from '../../Fashion/Heading'
import { Link } from 'react-router-dom'
import { useTranslation} from 'react-i18next';
import arrow from './../../../assets/img/custom/arrow.png'
import _ from 'lodash'
import BookingModal from '../../../page/bookingModal';
const InstgramSlider = (props) => {
  const { t, i18n } = useTranslation();
  let settings = {
    arrows: true,
    dots: false,
    margin:30,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }

    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
    ]
  };
  return (
    <>
      {props.container ? (
        <section id="instagram_area_one" >
          <div className="container mt-5">
            <Heading heading={t('ourspecialist')} para={t('ourspecialistsubheading')}/>
            <div className="row">
              <div className="col-lg-12">
                <div className="instagram_post_slider">
                  <Slider {...settings}>
                    {props?.TeamData?.map((data, index) => (
                      <div className="instgram_post" key={index}>
                        <a>
                          <div className="centerdiv">
                          <p className="font-weight-bold text-white">{data.name[i18n.language]}</p>
                                <p className="team-title text-white">{data.education[i18n.language]}</p>
                                <div className='team-title text-white small mb-3'>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60) + '...'}<Link  to={{
                          pathname: `/doctor-details/${(data.name.en)}/${i18n.language}`
                          , state: {
                              doctor: data
                          }
                      }}  className='text-warn font-weight-light ml-2'>{t('knowmore')} <img src={arrow} style={{ height: 10, width:30 }} className="d-inline" /></Link></div>
                               <BookingModal type="doctor" servicename={data.name[i18n.language]} service={data._id}/>
                          </div>
                          <img  src={process.env.REACT_APP_IMG_URL+data.image} />
                        </a>
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className='text-center'>
                <Link to={{ pathname: `/doctors` }} className="btn btn-warning font-weight-light mt-4">{t('viewalldoctors')}</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (

        <section id="instagram_area_one">
          <div className="container-fluid">
            <HeadingTwo heading="Follow Us Instagram" para="Follow Us and get updated from our instagram" />
            <div className="row">
              <div className="col-lg-12">
                <div className="instagram_post_slider">
                  <Slider {...settings}>
                    {InstgramData.map((data, index) => (
                      <div className="instgram_post" key={index}>
                        <a href="#!">
                          <i className={data.icon}></i>
                          <img src={data.img} alt="img" />
                        </a>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

    </>
  )
}

export default InstgramSlider